import { IApplicationState } from '../../types/redux';
import { IMortgageCalculatorSchema } from '../../repositories/special-promos/entities/get_cached_content/MortgageCalculatorSchema';

export function mortgageCalculatorSelector(state: IApplicationState): IMortgageCalculatorSchema | null {
  return state.specialPromosBlocks.mortgageCalculator;
}
